/* eslint-disable no-shadow */
/* eslint-disable react/display-name */
import * as React from "react";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { Box, Card, CardActions, CardContent, Typography } from "@material-ui/core";
import { FC, useState } from "react";
import { useDispatch } from "react-redux";

import Button from "../../../components/elements/Button";
import ConfirmationModal from "../../../components/modules/ConfirmationModal";
import EditTemplateModal from "../EditTemplateModal";
import api from "../../../api";
import classes from "./TemplateCard.module.scss";
import { CAMPAIGN_STEPS } from "../../../types/campaignTypes";
import { basicSteps } from "../../../constants/steps";
import { resetCampaignToCreateState } from "../../../redux/reducers/campaignToCreate";

type TemplateCardProps = {
  template: any;
  fetchTemplates: () => Promise<void>;
};

const TemplateCard: FC<TemplateCardProps> = ({ template, fetchTemplates }) => {
  const dispatch = useDispatch();
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState<boolean>(false);

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    dispatch(resetCampaignToCreateState());
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(false);
  };

  const handleConfirm = async () => {
    handleCloseConfirmationModal();
    try {
      await api.deleteCampaignTemplate(template.id);
      await fetchTemplates();
    } catch (error) {
      console.error("Failed to delete template:", error);
    }
  };

  return (
    <Card className={classes.cardWrap}>
      <CardContent>
        <Typography variant="h6" className={classes.cardTitle}>
          {template.templateName}
        </Typography>
        <Box className={classes.cardText}>
          {template.templateSteps
            .filter((step: string) => !basicSteps.includes(step as CAMPAIGN_STEPS))
            .map((step: string) => (
              <div className={classes.stepsWrap} key={step}>
                <div className={classes.iconWrapper}>
                  <CheckCircleIcon />
                </div>
                <Typography variant="body2" style={{ color: "text.secondary", marginBottom: 1.5 }}>
                  {step}
                </Typography>
              </div>
            ))}
        </Box>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <Button className={classes.editBtn} size="small" variant="outlined" onClick={() => setOpenEditModal(true)}>
          <EditIcon />
          <p>Edit</p>
        </Button>
        <Button
          className={classes.deleteBtn}
          size="small"
          variant="outlined"
          onClick={() => setOpenConfirmationModal(true)}
        >
          <DeleteIcon />
          <p>Delete</p>
        </Button>
      </CardActions>
      {openEditModal && (
        <EditTemplateModal isOpen={openEditModal} handleClose={handleCloseEditModal} templateToEdit={template} />
      )}
      {openConfirmationModal && (
        <ConfirmationModal
          isOpen={openConfirmationModal}
          confirmTitle="Confirm Deletion"
          cancelTitle="No"
          isCancelButton
          confirmQuestion="Are you sure you want to delete this template?"
          confirmButtonLabel="Yes"
          handleClose={handleCloseConfirmationModal}
          handleConfirm={handleConfirm}
        />
      )}
    </Card>
  );
};

export default TemplateCard;
